import { Reveal } from "@/components/Reveal";
import { BadgeCheck, Mail, Phone, Quote } from "lucide-react";

const ETHOS_QUOTE_URL = "https://agents.ethoslife.com/invite/c31bd";

export const Founder = () => (
  <section id="founder" data-testid="founder-section" className="relative overflow-hidden bg-obsidian py-28 lg:py-40">
    <div
      className="absolute left-1/3 top-0 h-[30rem] w-[30rem] rounded-full bg-gold/5 blur-[160px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2 lg:gap-24 lg:px-10">
      <Reveal>
        <div className="relative mx-auto max-w-md" data-testid="founder-portrait-frame">
          <div className="absolute -inset-3 border border-gold/40" aria-hidden="true" />
          <div className="absolute -inset-3 translate-x-5 translate-y-5 border border-gold/15" aria-hidden="true" />
          <div className="relative overflow-hidden">
            <img
              src="/roberta-portrait.png"
              alt="Roberta Rae Hare, Licensed Financial Strategist"
              data-testid="founder-portrait"
              className="aspect-[4/5] w-full object-cover object-top transition-transform duration-700 hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 via-transparent to-transparent" aria-hidden="true" />
            <div className="absolute bottom-5 left-5 flex items-center gap-2 border border-gold/30 bg-obsidian/80 px-4 py-2 backdrop-blur-md">
              <BadgeCheck size={14} className="text-gold" />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                License #21413773
              </span>
            </div>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="eyebrow mb-6" data-testid="founder-eyebrow">Meet Your Strategist</p>
          <h2 className="font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="founder-name">
            Roberta Rae Hare
          </h2>
          <p className="mt-3 font-mono text-xs uppercase tracking-[0.25em] text-gold/80" data-testid="founder-title">
            Licensed Financial Strategist · GFI Global Financial Impact
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <blockquote
            className="mt-10 border-l-2 border-gold/60 pl-6 font-display text-xl italic leading-relaxed text-white/85 sm:text-2xl"
            data-testid="founder-quote"
          >
            “Wealth is not luck — it is architecture. My work is to draft your family’s legacy,
            then protect it like it is my own family’s.”
          </blockquote>
          <p className="mt-8 max-w-lg text-base leading-relaxed text-white/55">
            From tax preparation to estate trusts, Roberta builds integrated financial strategies
            for families and business owners who refuse to leave their legacy to chance — guided by
            faith, family, fitness, finance, and fun.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href={ETHOS_QUOTE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-quote-button"
              className="flex items-center gap-3 bg-gold px-6 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-obsidian transition-all duration-300 hover:bg-gold-light"
            >
              <Quote size={14} /> Get a Free Quote
            </a>
            <a
              href="tel:+17709121516"
              data-testid="founder-call-button"
              className="flex items-center gap-3 border border-white/20 px-6 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-white/80 transition-all duration-300 hover:border-gold/60 hover:text-gold"
            >
              <Phone size={14} /> (770) 912-1516
            </a>
            <a
              href="mailto:robertaraehare.gfi@gmail.com"
              data-testid="founder-email-button"
              className="flex items-center gap-3 border border-white/20 px-6 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-white/80 transition-all duration-300 hover:border-gold/60 hover:text-gold"
            >
              <Mail size={14} /> Email Roberta
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
